import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row starter-main mt-5 pt-5" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4 flex-wrap"
}
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "pagination-mini" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-body" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "modal fade",
  id: "editModal",
  tabindex: "-1",
  "aria-labelledby": "editModalLabel",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = { class: "modal-title" }
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = ["readonly"]
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "modal-footer" }
const _hoisted_28 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import apiService from "@/services/apiService";
import CommonTable2 from "@/components/commen/table/CommonTable2.vue";
import TableTitle from "@/components/commen/table/TableTitle.vue";
import { usePermissions } from "@/composables/usePermissions";
const API_RESOURCE = "/common/cardstatus";
const pageTitle = "Card Status";
interface FetchOptions {
  page?: number;
  limit?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'cardstatusesList',
  setup(__props) {

const { canCreate, canUpdate } = usePermissions();

const title = ref("Card Statuses List");

const isCreateModalOpen = ref(false);
const isViewMode = ref(false);
const isDataLoaded = ref(false);

const tableConfig = ref({
  columns: [
    { name: "Title", field: "title", sortable: true },
    { name: "Color", field: "color", sortable: true },
  ],
  data: [] as any[],
  actions: [true],
  loading: false,
  showCategoryFilter: false,
  showStatusFilter: false,
  table_width: "max-content",
});

const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 1,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});

const newCardStatus = ref({
  title: "",
  color: "#cccccc",
});

const editingCardStatus = ref({
  _id: "",
  title: "",
  color: "#cccccc",
  createdAt: "",
  updatedAt: "",
});

function success_with_icon(message: string) {
  toast.success(message, {
    hideProgressBar: true,
    autoClose: 2000,
    theme: "colored",
  });
}

function error_with_icon(message: string) {
  toast.error(message, {
    hideProgressBar: true,
    autoClose: 2000,
    theme: "colored",
  });
}

const normalizeApiResponse = (
  payload: any
): { rows: any[]; pagination?: Record<string, any> } => {
  if (Array.isArray(payload)) {
    return { rows: payload };
  }

  const potentialArrays = [
    payload?.data,
    payload?.rows,
    payload?.items,
    payload?.result,
    payload?.cardStatuses,
    payload?.card_statuses,
    payload?.records,
    payload?.data?.rows,
    payload?.data?.items,
    payload?.data?.result,
    payload?.data?.cardStatuses,
    payload?.data?.card_statuses,
  ];

  for (const candidate of potentialArrays) {
    if (Array.isArray(candidate)) {
      return {
        rows: candidate,
        pagination: payload?.pagination || payload?.data?.pagination,
      };
    }
  }

  return { rows: [], pagination: payload?.pagination };
};

const syncPaginationState = (
  paginationMeta: Record<string, any> | undefined,
  fallback: { page: number; limit: number; totalItems: number }
) => {
  const resolvedPerPage =
    paginationMeta?.per_page ??
    paginationMeta?.perPage ??
    paginationMeta?.limit ??
    fallback.limit ??
    tablePagination.value.per_page;

  const fallbackTotal = fallback.totalItems;
  const resolvedTotal =
    paginationMeta?.total ??
    paginationMeta?.totalItems ??
    paginationMeta?.total_records ??
    fallbackTotal;

  const resolvedCurrent =
    paginationMeta?.current_page ??
    paginationMeta?.currentPage ??
    paginationMeta?.page ??
    fallback.page ??
    1;

  const computedTotalPages =
    paginationMeta?.total_pages ??
    paginationMeta?.totalPages ??
    (resolvedPerPage
      ? Math.ceil((resolvedTotal || 0) / resolvedPerPage)
      : tablePagination.value.total_pages);

  tablePagination.value.current_page = resolvedCurrent;
  tablePagination.value.per_page = resolvedPerPage || tablePagination.value.per_page;
  tablePagination.value.total = resolvedTotal ?? tableConfig.value.data.length;
  tablePagination.value.total_pages = Math.max(1, computedTotalPages || 1);
  tablePagination.value.has_prev = tablePagination.value.current_page > 1;
  tablePagination.value.has_next =
    tablePagination.value.current_page < tablePagination.value.total_pages;
};

const fetchData = async (
  { page = tablePagination.value.current_page, limit = tablePagination.value.per_page }: FetchOptions = {}
) => {
  tableConfig.value.loading = true;
  try {
    const response = await apiService.get(API_RESOURCE, { page, limit });
    const { rows, pagination } = normalizeApiResponse(response);
    tableConfig.value.data = Array.isArray(rows) ? [...rows] : [];
    syncPaginationState(pagination, {
      page,
      limit,
      totalItems: Array.isArray(rows) ? rows.length : 0,
    });
    isDataLoaded.value = true;

    const maxPage = Math.max(1, tablePagination.value.total_pages);
    if (page > maxPage) {
      await fetchData({ page: maxPage, limit });
      return;
    }
  } catch (error: any) {
    console.error("Error fetching Card Statuses:", error);
    tableConfig.value.data = [];
    error_with_icon(
      error.response?.data?.message ||
        error.message ||
        "Failed to load Card Status data."
    );
  } finally {
    tableConfig.value.loading = false;
    isDataLoaded.value = true;
  }
};

const saveData = async () => {
  if (!newCardStatus.value.title.trim()) {
    error_with_icon("Title is required.");
    return;
  }
  try {
    await apiService.post(API_RESOURCE, newCardStatus.value);
    success_with_icon("Card Status added successfully");
    closeCreateModal();
    newCardStatus.value = { title: "", color: "#cccccc" };
    await fetchData({ page: 1, limit: tablePagination.value.per_page });
  } catch (error: any) {
    console.error("Error saving Card Status:", error);
    error_with_icon(error.response?.data?.message || "Failed to add Card Status.");
  }
};

const updateData = async () => {
  if (!editingCardStatus.value.title.trim()) {
    error_with_icon("Title is required.");
    return;
  }
  try {
    const id = editingCardStatus.value._id;
    const updatePayload = {
      title: editingCardStatus.value.title,
      color: editingCardStatus.value.color,
    };
    await apiService.put(API_RESOURCE, id, updatePayload);
    success_with_icon("Card Status updated successfully");
    closeEditModal();
    await fetchData({
      page: tablePagination.value.current_page,
      limit: tablePagination.value.per_page,
    });
  } catch (error: any) {
    console.error("Error updating Card Status:", error);
    error_with_icon(error.response?.data?.message || "Failed to update Card Status.");
  }
};

const handleDelete = async (id: string) => {
  if (!confirm("Are you sure you want to delete this Card Status?")) {
    return;
  }
  try {
    await apiService.delete(API_RESOURCE, id);
    success_with_icon("Card Status deleted successfully");
    await fetchData({
      page: tablePagination.value.current_page,
      limit: tablePagination.value.per_page,
    });
  } catch (error: any) {
    console.error("Error deleting Card Status:", error);
    error_with_icon(error.response?.data?.message || "Failed to delete Card Status.");
  }
};

function showModal(modalId: string) {
  const modalElement = document.getElementById(modalId);
  if (modalElement) {
    const bootstrap = (window as any).bootstrap;
    if (bootstrap && bootstrap.Modal) {
      try {
        const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modalInstance?.show();
      } catch (e) {
        console.error(`Failed to show modal ${modalId} via Bootstrap JS:`, e);
        fallbackShow(modalElement);
      }
    } else {
      fallbackShow(modalElement);
    }
  }
}

function fallbackShow(modalElement: HTMLElement) {
  modalElement.classList.add('show');
  modalElement.style.display = 'block';
  document.body.classList.add('modal-open');
  if (!document.querySelector('.modal-backdrop')) {
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    document.body.appendChild(backdrop);
  }
}

function hideModal(modalId: string) {
  const modalElement = document.getElementById(modalId);
  if (!modalElement) return;

  const bootstrap = (window as any).bootstrap;
  if (bootstrap && bootstrap.Modal) {
    try {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        return; 
      }
    } catch (e) {
      console.warn(`Error hiding modal ${modalId} via Bootstrap JS, falling back to manual:`, e);
    }
  }
  fallbackHide(modalElement);
}

function fallbackHide(modalElement: HTMLElement) {
  modalElement.classList.remove('show');
  modalElement.style.display = 'none';
  const openModals = document.querySelectorAll('.modal.show');
  if (openModals.length === 0) {
    document.body.classList.remove('modal-open');
  }
  if (openModals.length === 0) {
     const backdrops = document.querySelectorAll('.modal-backdrop'); 
     backdrops.forEach(backdrop => backdrop.remove()); 
  }

}

const handleEdit = (row: any) => {
  isViewMode.value = false;
  editingCardStatus.value = { ...row };
  showModal('editModal');
};

const handleView = (row: any) => {
  isViewMode.value = true;
  editingCardStatus.value = { ...row };
  showModal('editModal');
};

const closeCreateModal = () => {
  hideModal("createNew");
  isCreateModalOpen.value = false;
  newCardStatus.value = { title: "", color: "#cccccc" };
};

const closeEditModal = () => {
  hideModal("editModal");
  isViewMode.value = false;
};

const openCreateModal = () => {
  isCreateModalOpen.value = true;
  showModal('createNew');
};

const changeRows = async () => {
  tablePagination.value.current_page = 1;
  await fetchData({ page: 1, limit: tablePagination.value.per_page });
};

const handlePageChange = async (page: number) => {
  if (typeof page !== "number" || Number.isNaN(page)) return;
  if (page < 1 || page === tablePagination.value.current_page) return;
  if (
    tablePagination.value.total_pages &&
    page > tablePagination.value.total_pages
  ) {
    return;
  }
  await fetchData({ page, limit: tablePagination.value.per_page });
};

onMounted(async () => {
  await fetchData({
    page: tablePagination.value.current_page,
    limit: tablePagination.value.per_page,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TableTitle, {
          title: title.value,
          pageTitle: pageTitle,
          icon: "fas fa-book",
          showAction: true,
          actionLabel: "Create New",
          modal: 'createNew',
          disabled: !_unref(canCreate)('data')
        }, null, 8, ["title", "disabled"]),
        (isDataLoaded.value)
          ? (_openBlock(), _createBlock(CommonTable2, {
              key: 0,
              tableObj: tableConfig.value,
              title: title.value,
              onEdit: handleEdit,
              onDelete: handleDelete,
              onView: handleView,
              permissionKey: "data"
            }, null, 8, ["tableObj", "title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (isDataLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm rows-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tablePagination.value.per_page) = $event)),
              onChange: changeRows
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                return _createElementVNode("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_5)
              }), 64))
            ], 544), [
              [
                _vModelSelect,
                tablePagination.value.per_page,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "page-btn prev_btn",
              disabled: !tablePagination.value.has_prev,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
            }, " « ", 8, _hoisted_7),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(["page-btn", {
          'page-active': p === tablePagination.value.current_page,
          'disabled-dots': p === '...',
        }]),
                disabled: p === '...',
                onClick: ($event: any) => (typeof p === 'number' && handlePageChange(p))
              }, _toDisplayString(p), 11, _hoisted_8))
            }), 128)),
            _createElementVNode("button", {
              class: "page-btn next_btn",
              disabled: !tablePagination.value.has_next,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
            }, " » ", 8, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", { 'show': isCreateModalOpen.value }]),
      id: "createNew",
      tabindex: "-1",
      "aria-labelledby": "createModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h3", { class: "modal-title" }, "Create " + _toDisplayString(pageTitle)),
            _cache[8] || (_cache[8] = _createElementVNode("button", {
              class: "btn-close py-0",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "form-label",
                for: "createTitle"
              }, "Title *", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "createTitle",
                placeholder: "Enter title",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newCardStatus.value.title) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, newCardStatus.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "form-label",
                for: "createColor"
              }, "Color", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "color",
                class: "form-control form-control-color",
                id: "createColor",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newCardStatus.value.color) = $event))
              }, null, 512), [
                [_vModelText, newCardStatus.value.color]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              "data-bs-dismiss": "modal",
              onClick: closeCreateModal
            }, " Close "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: saveData,
              disabled: !_unref(canCreate)('data')
            }, " Save changes ", 8, _hoisted_16)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(isViewMode.value ? "View" : "Edit") + " " + _toDisplayString(pageTitle), 1),
            _createElementVNode("button", {
              class: "btn-close py-0",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: closeEditModal
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "form-label",
                for: "editTitle"
              }, "Title *", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "editTitle",
                placeholder: "Enter title",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editingCardStatus.value.title) = $event)),
                readonly: isViewMode.value,
                required: ""
              }, null, 8, _hoisted_24), [
                [_vModelText, editingCardStatus.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                class: "form-label",
                for: "editColor"
              }, "Color", -1)),
              (!isViewMode.value)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "color",
                    class: "form-control form-control-color",
                    id: "editColor",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingCardStatus.value.color) = $event))
                  }, null, 512)), [
                    [_vModelText, editingCardStatus.value.color]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("span", {
                      class: "badge",
                      style: _normalizeStyle({ backgroundColor: editingCardStatus.value.color })
                    }, _toDisplayString(editingCardStatus.value.color), 5)
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              "data-bs-dismiss": "modal",
              onClick: closeEditModal
            }, " Close "),
            (!isViewMode.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  type: "button",
                  onClick: updateData,
                  disabled: !_unref(canUpdate)('data')
                }, " Save changes ", 8, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})